import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import config from 'config'

import history from 'srcReact/helpers/history'
import { urlSearchParams } from 'srcReact/helpers/utils'

import { settingsActions } from '../../action'
import styles from './styles.module.scss'
import { checkNested } from 'srcReact/helpers/validator'
import CloseAccountModal from '../CloseAccountModal'
import TransferRoleModal from '../TransferRoleModal'
import { isOrganizationManager } from 'srcReact/helpers/organizationHelper'
import BackNavigation from 'srcReact/components/common2/BackNavigation'

export default function SideBar({ openCloseAccountModal }) {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const location = history.location.pathname
  const {
    common: {
      transferRole: { loading, error, data }
    },
    common: { isNative, isMobile },
    organization
  } = useSelector((state) => state)
  const { notificationsformActive, organizationDocsActive, integrationActive } = useSelector((state) => state.settings)
  const [showModal, setShowModal] = useState(false)
  const [showTransferRoleModal, setShowTransferRoleModal] = useState(false)
  const [modalType, setModalType] = useState('')
  const [orgName, setOrgName] = useState('')

  useEffect(() => {
    if (location === '/0/settings/notifications') {
      dispatch(settingsActions.setNotificationFormActive(true))
    } else if (location === '/0/settings/account') {
      dispatch(settingsActions.setNotificationFormActive(false))
    } else if (location === '/0/settings/organization-documents') {
      dispatch(settingsActions.setOrgDocsActive(true))
      dispatch(settingsActions.setNotificationFormActive(false))
      dispatch(settingsActions.setIntegrationActive(false))
    } else if (location === '/0/settings/integrations') {
      dispatch(settingsActions.setIntegrationActive(true))
      dispatch(settingsActions.setNotificationFormActive(false))
      dispatch(settingsActions.setOrgDocsActive(false))
    }
  }, [location])
  useEffect(() => {
    if (data && data.deactivated === 0) {
      setShowTransferRoleModal(true)
    }
  }, [data])

  const handleNav = (nav) => {
    if (nav === 'notifications') {
      dispatch(settingsActions.setVerificationFormActive(false))
      dispatch(settingsActions.setUpdateFormActive(false))
      dispatch(settingsActions.setGroupFormActive(false))
      dispatch(settingsActions.setNotificationFormActive(true))
      dispatch(settingsActions.setIntegrationActive(false))
      dispatch(settingsActions.setOrgDocsActive(false))
    } else if (nav === 'account') {
      dispatch(settingsActions.setVerificationFormActive(false))
      dispatch(settingsActions.setUpdateFormActive(false))
      dispatch(settingsActions.setGroupFormActive(false))
      dispatch(settingsActions.setNotificationFormActive(false))
      dispatch(settingsActions.setIntegrationActive(false))
      dispatch(settingsActions.setOrgDocsActive(false))
    } else if (nav === 'documents') {
      dispatch(settingsActions.setVerificationFormActive(false))
      dispatch(settingsActions.setUpdateFormActive(false))
      dispatch(settingsActions.setGroupFormActive(false))
      dispatch(settingsActions.setNotificationFormActive(false))
      dispatch(settingsActions.setIntegrationActive(false))
      dispatch(settingsActions.setOrgDocsActive(true))
    } else if (nav === 'integrations') {
      dispatch(settingsActions.setVerificationFormActive(false))
      dispatch(settingsActions.setUpdateFormActive(false))
      dispatch(settingsActions.setGroupFormActive(false))
      dispatch(settingsActions.setNotificationFormActive(false))
      dispatch(settingsActions.setOrgDocsActive(false))
      dispatch(settingsActions.setIntegrationActive(true))
    }
  }

  const handleGoBack = () => {
    window.scrollTo(0, 0)
    // nativeapp
    if (isNative) {
      window.location = config.webUrl + '?goBack=true'
      return
    }
    history.goBack()
  }

  const hideModal = () => {
    setShowModal(false)
    setModalType('')
  }

  const hideTransferRoleModal = () => {
    setShowTransferRoleModal(false)
  }

  const openModal = (type) => {
    if (checkNested(organization, 'current_organization', 'info')) {
      if (isOrganizationManager(organization.current_organization)) {
        openCloseAccountModal(type)
      } else {
        if (isNative) {
          const currentOrg = urlSearchParams('current_organization')
          if (currentOrg && currentOrg.info) {
            setOrgName(currentOrg.info.name)
          }
        } else {
          setOrgName(organization.current_organization.info.name)
        }
        hideModal()
        setModalType(type)
        setShowModal(true)
      }
    }
  }

  return (
    <aside className={`${styles.mainWrapper}`}>
      <div className={`${styles.mainNav}`}>
        <BackNavigation customHandleBack={handleGoBack} className={styles.back} />
        <div className={`${styles.navGroup}`}>
          <Link
            to={
              isNative
                ? `/0/settings/account?organization_id=${urlSearchParams('organization_id')}`
                : `/0/settings/account`
            }
            onClick={() => handleNav('account')}
            className={`${styles.mainLink} ${
              notificationsformActive || organizationDocsActive || integrationActive ? '' : styles.active
            }`}>
            {t('account_settings.sidebar.first_main_nav')}
          </Link>
          <Link
            to={
              isNative
                ? `/0/settings/notifications?organization_id=${urlSearchParams('organization_id')}`
                : `/0/settings/notifications`
            }
            onClick={() => handleNav('notifications')}
            className={`${styles.mainLink} ${notificationsformActive ? styles.active : ''}`}>
            {t('account_settings.sidebar.second_main_nav')}
          </Link>
          <Link
            to={`/0/settings/integrations`}
            onClick={() => handleNav('integrations')}
            className={`${styles.mainLink} ${integrationActive && !notificationsformActive ? styles.active : ''}`}>
            {t('integration.title')}
          </Link>
          {(isMobile || isNative) && (
            <Link
              to={
                isNative
                  ? `/0/settings/organization-documents?organization_id=${urlSearchParams('organization_id')}`
                  : `/0/settings/organization-documents`
              }
              onClick={() => handleNav('documents')}
              className={`${styles.mainLink} ${
                organizationDocsActive && !notificationsformActive ? styles.active : ''
              }`}>
              {t('account_settings.sidebar.orgDocuments')}
            </Link>
          )}
        </div>
      </div>
      <div className={`${styles.bottomNav}`}>
        <div className={`${styles.navGroup}`}>
          {!isMobile && !isNative && (
            <Link
              to={
                isNative
                  ? `/0/settings/organization-documents?organization_id=${urlSearchParams('organization_id')}`
                  : `/0/settings/organization-documents`
              }
              onClick={() => handleNav('documents')}
              className={`${styles.mainLink} ${organizationDocsActive ? styles.active : ''}`}>
              {t('account_settings.sidebar.orgDocuments')}
            </Link>
          )}
          <Link to='/0/community-guidelines/'>{t('account_settings.sidebar.first_bottom_nav')}</Link>
          <Link to='/0/terms-of-services/'>{t('account_settings.sidebar.second_bottom_nav')}</Link>
          <Link to='/0/privacy-policy/'>{t('account_settings.sidebar.third_bottom_nav')}</Link>
          <button type='button' onClick={() => openModal('deactivate')}>
            {t('account_settings.sidebar.deactivateAcc')}
          </button>
          {/* <button type='button' onClick={() => openModal('delete')}>
            {t('account_settings.sidebar.deleteAcc')}
          </button> */}
        </div>
      </div>
      {showModal && modalType && (
        <CloseAccountModal orgName={orgName} showModal={showModal} modalType={modalType} hideModal={hideModal} />
      )}
      {showTransferRoleModal && (
        <TransferRoleModal showModal={showTransferRoleModal} hideModal={hideTransferRoleModal} screen='select-group' />
      )}
    </aside>
  )
}
